import { ElasticSearch } from '@interfaces/models/elasticSearch';

export type FavSortByOptions = 'price' | 'priceDesc' | 'recentPriceDrop' | 'dateDesc' | null;
export const IFS_DEFAULT_SORT_ORDER = 'relevance';
export const FAV_DEFAULT_SORT_ORDER = 'dateDesc';
export const FAV_SORT_OPTIONS: FavSortByOptions[] = ['price', 'priceDesc', 'recentPriceDrop', 'dateDesc'];
export const IFS_SORT_OPTIONS: ElasticSearch['sortBy'][] = ['relevance', 'price-asc', 'price-desc', 'recency'];
